import React from 'react';
import Container from 'react-bootstrap/Container';

import Banner from '../assets/images/aboutus/about-banner-long.jpeg'

const Sitemap = () => {
    return (
        <div>

            {/* Breadcrumb Navigation */}
            <section id="breadcrumbs" className="breadcrumbs"
                style={{
                    backgroundImage: `url(${Banner})`,
                }}
            >
                <div className="container">
                    <h1>Sitemap</h1>
                    <ul>
                        <li><a href="/">Home</a></li>
                        <li>Sitemap</li>
                    </ul>
                </div>
            </section>

            {/* Main Sitemap Section */}
            <section className="entry sitemap">
                <Container>
                    <ul>
                        <li><a href="/">Home</a></li>
                        <li><a href="/about-us">About Us</a></li>
                        <li><a href="/services">Services</a></li>
                        <li><a href="/gallery">Gallery</a></li>
                        <li><a href="/contact-us">Contact Us</a></li>
                        <li><a href="/privacy-policy">Privacy Policy</a></li>
                    </ul>
                </Container>
            </section>
            
        </div>
    );
};

export default Sitemap;
